import { getCurrency } from '../../../../cache';
import { Money } from '../../../../types';
import { getZeroPrice } from './getZeroPrice';
import { minMoney } from './minMoney';
import { reduceMoney } from './reduceMoney';

export const getMinPrice = <T>(items: T[], getItemPrice: (item: T) => Money | null | undefined): Money => {
	if (!items?.length) {
		return getZeroPrice();
	}

	const total = reduceMoney(items, getItemPrice, minMoney, { amount: Infinity, currency: null });

	return { ...total, currency: total.currency ?? getCurrency() };
};
